const CREATE_PURCHASE_NOTE_JOB_RESULT_FIELDS = `
  jobId
  status
  errorCode
  lastError
  createdAt
  updatedAt
  createdPurchaseNotes {
    purchaseNoteId
    purchaseNoteNumber
    serviceIds
    ticketIds
    idItinerary
    providerId
    currency
    purchaseNoteStatus
    reviewDate
    reservationNumber
    purchaseNoteObservation
    pdfStatus
    baseAmount
    commissionPercent
    commissionAmount
    total
  }
  rejectedServices {
    serviceId
    ticketId
    reason
    message
  }
  warnings {
    serviceId
    groupKey
    reason
    message
  }
`;

/** Igual que CreateOrder: el create puede devolver el job ya COMPLETED con el payload. */
export const CREATE_PURCHASE_NOTE_MUTATION = `
  mutation CreatePurchaseNote($input: CreatePurchaseNoteInput!) {
    createPurchaseNote(input: $input) {
      ${CREATE_PURCHASE_NOTE_JOB_RESULT_FIELDS}
    }
  }
`;

/**
 * UpdatePurchaseNoteResultType — igual que ORDER_UPDATE, con nombres NP.
 * Sin serviceIds/ticketIds/pdfStatus. Usa reviewDate (no scheduledPaymentDate).
 */
const PURCHASE_NOTE_UPDATE_RESULT_FIELDS = `
  purchaseNoteId
  purchaseNoteNumber
  purchaseNoteStatus
  reservationStatus
  reservationNumber
  reviewDate
  updatedAt
`;

export const GET_CREATE_PURCHASE_NOTE_JOB_QUERY = `
  query GetCreatePurchaseNoteJob($jobId: ID!) {
    getCreatePurchaseNoteJob(jobId: $jobId) {
      ${CREATE_PURCHASE_NOTE_JOB_RESULT_FIELDS}
    }
  }
`;

export const GET_PURCHASE_NOTES_BY_IDS_QUERY = `
  query GetPurchaseNotesByIds($purchaseNoteIds: [ID!]!) {
    getPurchaseNotesByIds(purchaseNoteIds: $purchaseNoteIds) {
      purchaseNoteId
      purchaseNoteNumber
      purchaseNoteStatus
      pdfStatus
      reviewDate
      reservationNumber
      purchaseNoteObservation
      serviceIds
      total
    }
  }
`;

export const CREATE_PURCHASE_NOTE_PDF_DOWNLOAD_URL_MUTATION = `
  mutation CreatePurchaseNotePdfDownloadUrl($purchaseNoteId: ID!, $disposition: String) {
    createPurchaseNotePdfDownloadUrl(purchaseNoteId: $purchaseNoteId, disposition: $disposition) {
      pdfStatus
      url
      expiresAt
      errorCode
      lastPdfError
    }
  }
`;

export const RETRY_GENERATE_PURCHASE_NOTE_PDF_MUTATION = `
  mutation RetryGeneratePurchaseNotePdf($purchaseNoteId: ID!) {
    retryGeneratePurchaseNotePdf(purchaseNoteId: $purchaseNoteId) {
      purchaseNoteId
      pdfStatus
      pdfGeneratedAt
    }
  }
`;

export const UPDATE_PURCHASE_NOTE_REVIEW_DATE_MUTATION = `
  mutation UpdatePurchaseNoteReviewDate($input: UpdatePurchaseNoteReviewDateInput!) {
    updatePurchaseNoteReviewDate(input: $input) {
      ${PURCHASE_NOTE_UPDATE_RESULT_FIELDS}
    }
  }
`;

export const UPDATE_PURCHASE_NOTE_RESERVATION_NUMBER_MUTATION = `
  mutation UpdatePurchaseNoteReservationNumber($input: UpdatePurchaseNoteReservationNumberInput!) {
    updatePurchaseNoteReservationNumber(input: $input) {
      ${PURCHASE_NOTE_UPDATE_RESULT_FIELDS}
    }
  }
`;

export const UPDATE_PURCHASE_NOTE_RESERVATION_STATUS_MUTATION = `
  mutation UpdatePurchaseNoteReservationStatus($input: UpdatePurchaseNoteReservationStatusInput!) {
    updatePurchaseNoteReservationStatus(input: $input) {
      ${PURCHASE_NOTE_UPDATE_RESULT_FIELDS}
    }
  }
`;

export const UPDATE_PURCHASE_NOTE_BY_ID_MUTATION = `
  mutation UpdatePurchaseNoteById($input: UpdatePurchaseNoteByIdInput!) {
    updatePurchaseNoteById(input: $input) {
      ${PURCHASE_NOTE_UPDATE_RESULT_FIELDS}
    }
  }
`;

export const DELETE_PURCHASE_NOTE_MUTATION = `
  mutation DeletePurchaseNote($input: DeletePurchaseNoteInput!) {
    deletePurchaseNote(input: $input) {
      ${PURCHASE_NOTE_UPDATE_RESULT_FIELDS}
    }
  }
`;
